// extracted by mini-css-extract-plugin
export default {"modalWindow":"modal_modalWindow__opDyn","modalContainer":"modal_modalContainer__atXQN","header":"modal_header__ZrtET","buttonClose":"modal_buttonClose__vNPWB"};